import { Subject } from 'rxjs'

const _closeJobSelectionDialog$ = new Subject<void>()
export const closeJobSelectionDialog$ = _closeJobSelectionDialog$.asObservable()

export const closeJobSelectionDialog = (): void => {
    _closeJobSelectionDialog$.next()
}
